import { removeNilValues } from '@lib/Object';
import Validator from '@lib/Validator';

export const resolver = (values, context) => {
  const { clabe } = values;
  const { borrowerBanks } = context;

  const errors = {
    clabe: Validator(clabe).required().isBankClabeValid({ banksCatalogue: borrowerBanks }).result(),
  };

  return { values, errors: removeNilValues(errors) };
};
